module.exports = __webpack_public_path__ + "img/Golden-CloseUp.86317a59.jpg";